<div class="offline-indicator">
    <p>
        <i class="fas fa-globe"></i>
        {{ title }}
    </p>

</div>
